import { User } from "@/common/Models";

export default interface UserService {
  getUser(): User | null;
  setUser(user: User | null): void;
}
